import { adminV2ReceiptUpdateLogs } from "@api/all";
import { Dashboard } from "@lib/pageBuilder/pagesHelper";
import React from "react";
import { useParams } from "react-router-dom";

export function ReceiptActivity() {
  const params = useParams();

  return (
    <Dashboard
      fetchPath={adminV2ReceiptUpdateLogs.index.path({
        receipt_id: params.receipt_id,
      })}
      action={null}
      searchKey="admin"
    />
  );
}
